import React from 'react'
import {Card, Grid, Header, Label} from 'semantic-ui-react'
import {resume} from './resume'

export default class Experience extends React.Component {
    WorkInfo = () => {
        const infos = resume.work;            
        return (
            <Grid divided='vertically' className='experience'>
                {infos.map((key,id) => {
                    return (
                        <Grid.Row key={id}>
                            <Grid.Column textAlign='left'>
                                <Header as='h4'>
                                    {key.company}
                                </Header>
                                <Header as='h5'>
                                    {key.position}
                                </Header>
                                <p>{'Period:' + key.period}</p>
                                <div role="list" class="ui bulleted list">
                                {key.summary.map(summary => (
                                    <div role="listitem" class="item">{summary}</div>))}
                                </div>
                                {key.highlights.map(skill => (
                                    <Label key={skill}>{skill}</Label>
                                ))}
                            </Grid.Column>
                        </Grid.Row>
                    );
                })}
            </Grid>
        )
    }
    render() {
        const workDom = this.WorkInfo();
        return (
            <Card id='work_experience' className='summary' fluid>
                <Card.Content>
                    <Card.Header textAlign='left'>Work Experience</Card.Header>
                </Card.Content>
                <Card.Content>
                    <Grid>
                        {workDom}
                    </Grid>
                </Card.Content>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Infos/experience.js